import request from "@/router/axios";
export const buildSchedule = (resourceId) => {
  return request({
    url: `/api/jc/schedule/plan/buildSchedule`,
    method: "post",
    params: {
      resourceId,
    },
  });
};
export const loadSchedule = (resourceId, start, end) => {
  return request({
    url: `/api/jc/schedule/plan/loadSchedule`,
    method: "get",
    params: {
      resourceId,
      start,
      end,
    },
  });
};
export const getScheduleDetail = (resourceId, date) => {
  return request({
    url: `/api/jc/schedule/plan/getScheduleDetail`,
    method: "get",
    params: {
      resourceId,
      date,
    },
  });
};
export const projectSchedule = (projectId, start, end) => {
  return request({
    url: `/api/jc/schedule/plan/projectSchedule`,
    method: "get",
    params: {
      projectId,
      start,
      end,
    },
  });
};
export const projectScheduleDetail = (scheduleIds) => {
  return request({
    url: `/api/jc/schedule/plan/projectScheduleDetail`,
    method: "get",
    params: {
      scheduleIds,
    },
  });
};
export const stop = (scheduleDate,scheduleIds) => {
  return request({
    url: `/api/jc/schedule/plan/stop`,
    method: "post",
    params: {
      scheduleDate,
      scheduleIds,
    },
  });
};
export const regain = (scheduleDate,scheduleIds) => {
  return request({
    url: `/api/jc/schedule/plan/regain`,
    method: "post",
    params: {
      scheduleDate,
      scheduleIds,
    },
  });
};
export const add = (data) => {
  return request({
    url: `/api/jc/schedule/plan/add`,
    method: "post",
    data,
  });
};
export const getCyclesAndShifts = (type, id) => {
  return request({
    url: `/api/jc/schedule/rule/getCyclesAndShifts`,
    method: "get",
    params: {
      type,
      id,
    },
  });
};
export const getScheduleResources = () => {
  return request({
    url: `/api/jc/schedule/rule/getScheduleResources`,
    method: "get",
  });
};
export const queryCycle = (type, id) => {
  return request({
    url: `/api/jc/schedule/cycle/query`,
    method: "get",
    params: {
      type,
      id,
    },
  });
};
export const queryRule = (ruleId) => {
  return request({
    url: `/api/jc/schedule/rule/query`,
    method: "get",
    params: {
      ruleId,
    },
  });
};
export const saveRule = (data) => {
  return request({
    url: `/api/jc/schedule/rule/saveRule`,
    method: "post",
    data,
  });
};
export const delRule = (ruleId) => {
  return request({
    url: `/api/jc/schedule/rule/delRule`,
    method: "post",
    params: {
      ruleId,
    },
  });
};
export const saveTempSchedule = (data) => {
  return request({
    url: `/api/jc/schedule/plan/saveTempSchedule`,
    method: "post",
    data,
  });
};
export const plus = (scheduleIds,num) => {
  return request({
    url: `/api/jc/schedule/plan/plus`,
    method: "post",
    params: {
      scheduleIds,
      num
    },
  });
};
export const reSchedule = (resId) => {
  return request({
    url: `/api/jc/schedule/rule/reSchedule`,
    method: "post",
    timeout: 300000,
    params: {
      resId,
    },
  });
};